// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { Auth } from 'aws-amplify';
import React, { useContext, useState, useEffect } from 'react';
import EmailImage from './assets/email.png'
import LoginLayout from '../../layouts/LoginLayout';
import { Link, Redirect } from 'react-router-dom';
import { getQueryParams, useQuery } from '../../lib/utility';
import MemberContext from '../../contexts/MemberContext';
import S from './styles';
import { FormattedMessage, useIntl } from 'react-intl';

const ConfirmEmailPage = (): JSX.Element => {
  const { email } = getQueryParams(useQuery());
  const [resend, setResend] = useState<boolean>(false);
  const member = useContext(MemberContext);
  const intl = useIntl();
  if (member.isLogin) {
    return (
      <Redirect to="/home"></Redirect>
    )
  }
  useEffect(() => {
    if (resend) {
      console.log({ resend })
      setTimeout(() => {
        console.log({ resend })
        setResend(false)
      }, 30000);
    }
  }, [resend]);
  const resendCode = () => {
    console.log({ email })
    Auth.resendSignUp(email)
      .then((data) => {
        console.log({ data })
        setResend(true)
      })
      .catch((error) => {
        console.log({ error });
      })
  }

  return (
    <LoginLayout>
      <S.Wrapper>
        <S.Img src={EmailImage} alt="" />
        <S.DescriptionWrapper>
          <S.Title>{intl.formatMessage({ id: 'J032' })}</S.Title>
          <S.Description>
            <FormattedMessage id="J033" values={{registeredEmail: email, br: <br/>}}/>
          </S.Description>
        </S.DescriptionWrapper>
        <S.Wait30Description>{resend && `*${intl.formatMessage({ id: 'J036' })}`}</S.Wait30Description>
        <S.ButtonWrapper>
          <S.LoginButton as={Link} to={'/login'}>{intl.formatMessage({ id: 'J034' })}</S.LoginButton>
          <S.RetryButton disabled={resend } onClick={resendCode}>{intl.formatMessage({ id: 'J035' })}</S.RetryButton>
        </S.ButtonWrapper>
      </S.Wrapper>
    </LoginLayout>
  );
}

export { ConfirmEmailPage as default }
